export default itemCount => (itemCount > 0 ? itemCount : "zero");
